import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filters from 'views/agent/configuration/securityChanges/filter'; // Importing Filters component
import Table from 'views/agent/configuration/securityChanges/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the security changes view.
 * @extends JetView
 */
export default class securityChangesView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const toolbar = {
            view: 'toolbar', // Toolbar component
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for QR section
                    css: theme, // Apply current theme
                    elements: [{ view: 'label', label: _('QR'), width: 150 }], // Label for QR
                },
                {
                    view: 'template', // Template for displaying QR code
                    id: 'templateQR', // Unique identifier for the template
                    onClick: {
                        copy_text: function (ev, id) {
                            // Click event to copy text
                            var copyText = document.getElementById('lname'); // Get input element
                            copyText.select(); // Select the text
                            copyText.setSelectionRange(0, 99999); // Set selection range
                            document.execCommand('copy'); // Execute copy command
                            webix.message(_('QR Copiado!')); // Show message on copy
                        },
                    },
                },
                {
                    view: 'label', // Label for error message
                    label: 'No tienes un QR Configurado.', // Error message text
                    localId: 'label', // Local identifier for the label
                    id: 'labelError', // Unique identifier for the error label
                },
            ],
        };
        return {
            type: 'wide', // Layout type
            cols: [left], // Columns configuration
        };
    }

    /**
     * Initializes the view and fetches QR code data.
     */
    init() {
        const cur_user = this.getParam('user', true); // Get current user parameter
        $$('labelError').hide(); // Hide error label initially
        webix
            .ajax() // AJAX request to fetch QR code
            .get(
                devConfig.geturlApi() + 'Client/GetQRGoogle', // API endpoint
                'id=' + cur_user, // Query parameter with user ID
                {
                    error: function (text, data, XmlHttpRequest) {
                        // Error handling
                        webix.message('Error! '); // Show error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        // Success handling
                        var text = JSON.parse(text); // Parse response text
                        if (!text.HasError) {
                            // Check for errors in response
                            $$('templateQR').show(); // Show QR template
                            $$('labelError').hide(); // Hide error label
                            $$('templateQR').setHTML(
                                // Set HTML content for QR template
                                `<div style="text-align: center;">
                          <img style="display:inline-block" src="` +
                                    text.data +
                                    `"> // Display QR image
                       </div>
                       <br>
                       <div style="text-align: center;">
                          <input type="text" id="lname" name="lname"
                              style="width: 50%;
                              padding: 12px 20px;
                              margin: 8px 0;
                              display: inline-block;
                              border: 1px solid #ccc;
                              border-radius: 4px;
                              box-sizing: border-box;
                              text-align: center;"
                              value="` +
                                    text.text +
                                    `"> // Input field for QR text
                          <button class='button-login copy_text'
                            style="
                            background-color: #263043 !important;
                            color: white;
                            padding: 14px 20px;
                            margin: 8px 0;
                            border: none;
                            border-radius: 4px;
                            cursor: pointer;"><span class="icon-copy"></span></button> // Button to copy text
                       </div>
                      `,
                            );
                        } else {
                            $$('templateQR').hide(); // Hide QR template on error
                            $$('labelError').show(); // Show error label
                        }
                    },
                },
            );
    }
}

// FILE DOCUMENTED
